<style src="./EventFilter.scss" lang="scss"></style>
<template>
  <form
    @submit.prevent="submitFilter"
    class="event-filter">
    <label class="field search">
      <span class="title">Buscar Evento</span>
      <input
        type="text"
        v-model="form.searchText"
        placeholder="Digite o identificador do evento"
        class="cp1-small-textbox" />
    </label>

    <label class="field date">
      <span class="title">Data Inicial</span>
      <input
        type="date"
        class="cp1-small-textbox"
        v-model="form.startDate" />
    </label>

    <label class="field date">
      <span class="title">Data Final</span>
      <input
        type="date"
        class="cp1-small-textbox"
        v-model="form.endDate" />
    </label>

    <div class="field status">
      <span class="title">Status</span>
      
      <div class="options">
        <button
          type="button"
          @click="toggleReproved"
          :class="{ 'toggle__active': form.reproved }"
          class="cp1-small-button">
          Reprovado
        </button>
        <button
          type="button"
          @click="toggleCanceled"
          :class="{ 'toggle__active': form.canceled }"
          class="cp1-small-button">
          Cancelado
        </button>
        <button
          type="button"
          @click="toggleSuspendedNoDate"
          :class="{ 'toggle__active': form.suspendedNoDate }"
          class="cp1-small-button">
          Suspenso
        </button>
      </div>
    </div>

    <div class="field modality">
      <span class="title">Modalidades</span>
      
      <div class="checkbox">
        <label
          class="panel"
          v-for="(modality, modalityIdx) in lists.modalities"
          :key="modalityIdx">
          <input
            class="panel-input"
            type="checkbox"
            v-model="lists.selectedModalities[modality.value]">
          <span class="panel-label">{{ modality.text }}</span>
        </label>
      </div>
    </div>

    <div class="field command">
      <button
        class="cp1-small-button btn-primary button">
        Buscar
      </button>
    </div>
  </form>
</template>

<script>
import moment from 'moment'

export default {
  name: 'EventFilter',
  data: () => ({
    form: {
      selectedBoard: '',
      searchText: '',
      startDate: '',
      endDate: '',
      reproved: false,
      canceled: false,
      suspendedNoDate: false,
      modalities: {}
    },
    lists: {
      selectedBoard: '',
      boards: [],
      modalities: [],
      selectedModalities: {}
    }
  }),
  async mounted () {
    this.loadModalities()
    await this.listBoards()
    this.setInitialForm()
    this.submitFilter()
  },
  methods: {
    submitFilter () {
      this.$emit('submit-filter', {
        form: this.form,
        list: this.lists
      })
    },
    loadModalities () {
      const modalities = this.$store.getters['Events/GET_MODALITIES']

      this.lists.modalities = modalities

      let listSelected = {}
      modalities.map(m => {
        listSelected[m.value] = m.checked
      })
      this.lists.selectedModalities = listSelected
    },
    setInitialForm () {
      const existsFilterData = this.$store.getters['Board/FILTERS']
      if (existsFilterData.selectedBoard) {
        this.form.startDate = existsFilterData.startDate
        this.form.endDate = existsFilterData.endDate
        this.form.searchText = existsFilterData.searchText
        this.form.reproved = existsFilterData.reproved
        this.form.canceled = existsFilterData.canceled
        this.form.suspendedNoDate = existsFilterData.suspendedNoDate
        this.form.selectedBoard = existsFilterData.selectedBoard
        this.form.selectedModalities = existsFilterData.modalities
        this.form.selectedBoard = existsFilterData.selectedBoard
      } else {
        const dt = new Date()
        this.form.startDate = moment(dt).format('YYYY-MM-DD')
        this.form.endDate = moment(dt).add(1, 'month').format('YYYY-MM-DD')
        this.form.selectedBoard = this.lists.boards[0].value
      }
    },
    async listBoards () {
      const { boards } = await this.$store.dispatch('Board/LIST_BOARDS')
      const boardList = boards.map(board => ({
        text: board.name,
        value: board._id
      }))
      this.lists.boards = boardList
      this.lists.selectedBoard = boardList[0].value
    },
    toggleReproved () {
      this.form.reproved = !this.form.reproved
    },
    toggleCanceled () {
      this.form.canceled = !this.form.canceled
    },
    toggleSuspendedNoDate () {
      this.form.suspendedNoDate = !this.form.suspendedNoDate
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/board/components/event-filter/EventFilter.vue